import { createSlice } from '@reduxjs/toolkit';

export const servicesIaGlobalConfigSlice = createSlice({
  name: 'servicesIaGlobalConfig',
  initialState: {
    global_config_list: [],
    global_config: {},
    applicationsListSelect: [],
  },
  reducers: {
    setGlobalConfigListRedux: (state, { payload }) => {
      state.global_config_list = payload;
    },
    setGlobalConfigRedux: (state, { payload }) => {
      state.global_config = payload;
    },
    setApplicationsListSelectRedux: (state, { payload }) => {
      state.applicationsListSelect = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setGlobalConfigListRedux, setGlobalConfigRedux, setApplicationsListSelectRedux } =
  servicesIaGlobalConfigSlice.actions;
